var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M23.52 12.773c0-.851-.076-1.67-.218-2.455H12v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.01h3.878c2.269-2.088 3.578-5.165 3.578-8.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12 24.5c3.24 0 5.956-1.075 7.942-2.907l-3.878-3.011c-1.075.72-2.45 1.145-4.064 1.145-3.125 0-5.77-2.11-6.715-4.947H1.276v3.11A12 12 0 0 0 12 24.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M5.285 14.78a7.2 7.2 0 0 1-.376-2.28c0-.79.136-1.56.376-2.28V7.11H1.276A12 12 0 0 0 0 12.5c0 1.936.464 3.77 1.276 5.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12 5.273c1.762 0 3.344.605 4.587 1.794l3.442-3.442C17.951 1.69 15.235.5 12 .5 7.31.5 3.25 3.19 1.276 7.11l4.01 3.11C6.228 7.384 8.874 5.273 12 5.273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h24v24H0z"
  }))));
};
export default SvgGoogle;